/* global REACT_APP_API_BASE_URL:true */
import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

export async function getTBDShipments(_, params) {
  const { current, pageSize, filters, GetConfirmedWithPendingQuotes, GetAll, userId, entityId } = params || {};
  const paramsPayload = {
    PageNumber: current || 1,
    PageSize: pageSize || 100,
    GetConfirmedWithPendingQuotes,
    GetAll,
    userId,
    entityId,
  };

  if (filters) {
    paramsPayload.filterBy = "";
    paramsPayload.filterValue = "";
    paramsPayload.filterCount = 0;

    filters.forEach((filter, index) => {
      paramsPayload.filterBy += `${filter.split(":")?.[0]}${filters.length - 1 === index ? "" : "|"}`;
      paramsPayload.filterValue += `${filter.split(":")?.[1]}${filters.length - 1 === index ? "" : "|"}`;
      paramsPayload.filterCount += 1;
    });
  }

  const result = await request(`${REACT_APP_API_BASE_URL}/api/Shipments/GetTBD`, {
    method: "GET",
    params: paramsPayload,
  });

  return result;
}

export async function getSingleAdminShipment(shipmentId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/admin/${shipmentId}`, {
    method: "GET",
  });
  return result?.data;
}

export async function getSingleShipment(shipmentId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/${shipmentId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getAdminVehicles(shipmentId) {
  const params = cleanObjectFromUndefined({
    ShipmentId: shipmentId,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin`, {
    method: "GET",
    params,
  });

  return result?.data;
}

/*
  Function is named getLoads, but really gets a list of vehicles with associated load data.
  Old function -JH
*/
export async function getLoads(_, payload) {
  let result = await request(`${REACT_APP_API_BASE_URL}/api/Dealer/Loads/Shipments/${payload.shipmentId}`, {});

  if (result.status === 404) {
    result = [];
  } else {
    //  result = result;
  }

  return result?.data;
}

export async function confirmShipment(shipmentId) {
  const data = {};

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/post/${shipmentId}`, {
    method: "PATCH",
    data,
  });

  return result?.data;
}

export async function editShipment(_, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Dealer/Shipments`, {
    method: "PATCH",
    data: payload,
  });

  return result ? result?.data : { error: true };
}

export async function toggleInternalShipment(_, shipmentId, status) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Shipments/${shipmentId}/isInternalShipment`, {
    method: "PATCH",
    params: { isInternalShipment: status },
  });

  return result?.data;
}

export async function getShipmentCount(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/count`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getDealerDashboardMap() {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/dealer-dashboard-map`, {
    method: "GET",
  });

  return result?.data;
}

export async function transferVehicle(vehicleId, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/transfer/${vehicleId}`, {
    method: "PUT",
    data: payload,
  });

  if (result) {
    const { response } = result;
    return response && response.ok && response.status === 200;
  }

  return result;
}

export async function multiplePostShipment(payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/admin/post-multiple`, {
    method: "PATCH",
    data: { ids: payload },
  });

  return result || { error: true };
}

export async function toggleEscalation(shipmentId) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/toggle-escalation/${shipmentId}`,
    {
      method: "PATCH",
    },
  );

  return result || { error: true };
}

export async function toggleExpedited(shipmentId, reason) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/toggle-expedited/${shipmentId}`,
    {
      method: "PATCH",
      params: { reason },
    },
  );

  return result || { error: true };
}

export async function toggleVisible(shipmentId) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/toggle-visible/${shipmentId}`,
    {
      method: "PATCH",
    },
  );

  return result || { error: true };
}

export async function toggleProblemRide(shipmentId, reason) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/toggle-problem-ride/${shipmentId}`,
    {
      method: "PATCH",
      params: { reason },
    },
  );

  return result || { error: true };
}

export async function toggleDealerExchangeRequired(shipmentId) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/toggle-exchange-required/${shipmentId}`,
    {
      method: "PATCH",
    },
  );

  return result || { error: true };
}

export async function toggleHardRoute(shipmentId, location, reason, note) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/toggle-hard-route/${shipmentId}`,
    {
      method: "PATCH",
      data: {
        location,
        reason,
        note,
      },
    },
  );

  return result || { error: true };
}

export async function requestRunningLateStatusUpdate(_, shipmentId) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Shipments/${shipmentId}/SendShipmentStatus`, {
    method: "POST",
  });

  return result || { error: true };
}

export async function unlinkExistingDealerExchange(shipmentId) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/delete-exchange/${shipmentId}`,
    {
      method: "Delete",
    },
  );

  if (result?.response && result?.response.ok && result?.response?.status === 204) {
    return result;
  }

  return { error: true };
}

export async function requestPrices(shipmentId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments/request-price/${shipmentId}`, {
    method: "PATCH",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}
